import { Component, inject, Input } from '@angular/core';
import {  ListTableComponent  } from '@ppl/ui';
import { TableRowActionsModel } from '../../../shared/interfaces/list.interface';
import { TableRowActions } from '../../../shared/interfaces/actions';
import { GridAction } from '@ppl/ui';
import { LeadDetailsService } from '../../../services/lead-details.service';
import { throwError } from 'rxjs';
import {
  ProviderHealthAssessment,
  ProviderHealthAssessmentResponseData,
} from '../../../shared/interfaces/lead-details.service-types';
import { GlobalErrorHandlerService } from '../../../shared/services/global-error-handler.service';
import { STATIC_DATA } from '../../../shared/constants/static-data.constants';
import { AccordionComponent } from '@ppl/ui';
import { environment } from '../../../../environments/environment';
import { UserService } from '../../../services/user.service';

const healthAssessmentColumns = [
  {
    field: 'value',
    header: 'Result',
    jsonpath: 'value',
    isDisplayedAtHeader: 'y',
    isSearchable: 'n',
  },
  {
    field: 'start_date',
    header: 'Start Date',
    jsonpath: 'start_date',
    isDisplayedAtHeader: 'y',
    isSearchable: 'n',
  },
  {
    field: 'end_date',
    header: 'Expiration',
    jsonpath: 'end_date',
    isDisplayedAtHeader: 'y',
    isSearchable: 'n',
  },
];

const pendingProviderHealthAssessment: ProviderHealthAssessment = {
  description: 'Health Assessment Complete',
  value: 'Pending',
  start_date: null,
  end_date: null,
  is_active: null,
};

const mobileHealthScheduleLink = environment.mobileHealthUrl;

@Component({
  selector: 'ppl-health-assessment-list',
  standalone: true,
  imports: [ListTableComponent, AccordionComponent],
  templateUrl: './health-assessment-list.component.html',
  styleUrl: './health-assessment-list.component.css',
})
export class HealthAssessmentListComponent {
  @Input({ required: true }) programCode!: string;

  cols = [...healthAssessmentColumns];
  actionButtons: TableRowActionsModel | null = null;

  selectedProviderId: number | null = null;
  healthAssessmentGridData: ProviderHealthAssessment[] | null = null;

  leadDetailsService = inject(LeadDetailsService);
  errorHandler = inject(GlobalErrorHandlerService);
  userService = inject(UserService);
  providerEmail = '';

  ngOnInit() {
    const storedProviderId: string = JSON.parse(
      this.userService.getSelectedLead()!,
    );
    this.selectedProviderId = storedProviderId ? +storedProviderId : null;
    this.fetchHealthAssessmentData();
  }

  fetchHealthAssessmentData() {
    if (this.selectedProviderId) {
      this.leadDetailsService
        .fetchProviderHealthAssessment(
          this.programCode,
          this.selectedProviderId,
        )
        .subscribe({
          next: (apiResponse) => {
            if (apiResponse?.responsedata?.email) {
              this.providerEmail = apiResponse.responsedata.email;
            }
            if (apiResponse?.responsedata?.assessments?.length === 0) {
              // No data from Mobile Health, show "Pending" row
              this.setPendingRow();
            } else if (apiResponse?.responsedata?.assessments?.length > 0) {
              // Capitalize the first letter of the 'value' property
              this.healthAssessmentGridData = apiResponse.responsedata.assessments.map((assessment) => {
              let value = assessment.value
                ? assessment.value.charAt(0).toUpperCase() + assessment.value.slice(1)
                : assessment.value;
              if (value?.includes('Pass') && (!assessment.end_date || (assessment.end_date && new Date(assessment.end_date) < new Date()))) {
                value = value ? value + ' (Expired)' : 'Expired';
              }
              return {
                ...assessment,
                value,
              };
            });
            } else {
              this.healthAssessmentGridData = null;
            }
            this.actionButtons = new TableRowActions({ schedule: true });
          },
          error: (err) => {
            throwError(() => this.errorHandler.handleError(err));
          },
        });
    }
  }

  setPendingRow() {
    this.healthAssessmentGridData = [{ ...pendingProviderHealthAssessment }];
    this.actionButtons = new TableRowActions({ schedule: true });
  }

  action(event: GridAction) {
    const { action } = event;
    if (action === 'schedule') {
      window.open(mobileHealthScheduleLink, '_blank');
    }
  }
}
